//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React from "react";

const AdminModalHeader = ({ title, headerContent }) => (
  <div>
    <div className="modal-header">
      <h5 className="modal-title request-modal--title">{title}</h5>
      <button
        type="button"
        className="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    {headerContent}
  </div>
);

export default observer(AdminModalHeader);
